module.exports = __webpack_public_path__ + "static/img/医院AI审核_产品截图1@2x.410b7f39.png";